export default "__VITE_ASSET__C6ql2W$d__"